import { Customer } from "../../parties/model/customer.model";

export class SmartClubModel {
  codeOrMobile: string;
  posUserId: string;
  orderType: number;
  retry: boolean;
  usedCredit: number;
  usedDiscountPercent: number;
  factorId: number;
  HasError: boolean;
  ErrorMessage: string;
  BranchId?: number;
  public HasClub: boolean;
  public ClubCode: number;
  public InvoiceId: number;
  usedProductDiscounts: UsedProductDiscountModel[];
  constructor() {
    this.codeOrMobile = "";
    this.posUserId = null;
    this.orderType = 0;
    this.retry = false;
    this.usedCredit = 0;
    this.usedDiscountPercent = 0;
    this.factorId = 0;
    this.HasError = false;
    this.HasClub = false;
    this.ClubCode = null;
    this.InvoiceId = null;
    this.usedProductDiscounts = [];
    this.BranchId = null;
  }
}
export class UsedProductDiscountModel {
  ProductId: number;
  UsedCount: number;
}
export class ClubViewModel {
  Customer: Customer;
  CustomerInquiryResponseStatus: number;
  /// <summary>
  /// مبلغ کل اعتبار کاربر
  /// این قیمت فقط جهت اطلاع است  و کاربرد دیگری ندارد
  /// </summary>
  public Wallet: number; //
  /// <summary>
  /// مبلغ اعتبار کاربر که در این لحظه میتواند استفاده کند
  /// </summary>
  public AvailableCredit: number; //
  /// <summary>
  /// لاک نامبر
  /// </summary>
  public BranchCloudConsumerId: number; //
  public Message: string; //
  public DiscountPercent: number; //
  /// <summary>
  /// سقف تخفیف درصدی
  /// </summary>
  public MaxUsablePriceFromDiscountPercent: number; //
  /// <summary>
  /// حداقل مبلغ فاکتور جهت استفاده تخفیف درصدی
  /// </summary>
  public MinFactorPriceToActiveDiscountPercent: number; //
  /// <summary>
  /// لیست محصولات همراه با میزان تخفیف
  /// </summary>
  public ProductDiscounts: ProductDiscount[]; //
  public UsedProductDiscount: UsedProductDiscount[]; //
  public DiscountPrice: number; //
  public UseCreditPrice: number; //
  public usedDiscountPercent: number; //
  public usedCredit: number; //
  public isDisableusedCredit: boolean; //
  public CreditPrice: number; //
  public ClubTotalDiscount: number; //
  public OperatorPhone: string;
  public Code: string; //
  Phone: string;
  LongMobile: string;
  UsedCreditResponseId: string;
  CustomerName: string;
  PosCustomerOriginalId?: number;
  constructor() {
    this.AvailableCredit = 0;
    this.CreditPrice = 0;
    this.OperatorPhone = "";
    this.UseCreditPrice = 0;
    this.usedDiscountPercent = 0;
    this.usedCredit = 0;
    this.ClubTotalDiscount = 0;
    this.DiscountPrice = 0;
    this.BranchCloudConsumerId = null;
    this.Code = null;
    this.DiscountPercent = null;
    this.MaxUsablePriceFromDiscountPercent = null;
    this.Message = null;
    this.MinFactorPriceToActiveDiscountPercent = null;
    this.Phone = null;
    this.ProductDiscounts = null;
    this.Wallet = null;
  }
}
export class ProductDiscount {
  public ProductId: number;
  public Percentage: number;
  public QuantityRemain: number;
}
export class UsedProductDiscount {
  public ProductId: number;
  public UsedCount: number;
}
